.footer {
  padding: 64px 0 16px;
  pointer-events: none;
  background: #f9f9f9;
}

.footerContent {
  width: 1126px;
  margin-inline: auto;
}

.listsWrapper {
  display: grid;
  grid-template-columns: 280px 1fr 280px;
}

.title {
  margin-bottom: 12px;
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
}

.list {
  display: grid;
  grid-template-rows: repeat(5, auto);
  grid-auto-flow: column;
  gap: 12px;
}

.listLink {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  cursor: pointer;

  &:hover {
    color: var(--color-text-primary);
    text-decoration: underline;
  }
}

.footerFooter {
  padding: 16px 0 12px;
  margin-top: 100px;
  border-top: 1px solid var(--color-border-normal);
}

.footerList {
  display: flex;
}

.footerListItem {
  & + & {
    margin-left: 24px;
  }
}

.copyright {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.dropdownTrigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  border-bottom: 1px solid var(--color-border-dark);
}
